import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-copper/20 last:border-0" data-id="element-27">
      <button onClick={onClick} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-28">
        <span className="text-lg md:text-xl font-heading font-semibold text-navy group-hover:text-copper transition-colors pr-8" data-id="element-29">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-copper flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30" />
      </button>
      <AnimatePresence data-id="element-31">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-32">
            <p className="pb-6 text-text-dark/80 font-body leading-relaxed text-lg" data-id="element-33">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Does this work in my state?',
    a: 'Yes. While probate laws vary, the Mortgage Shield and CFPB protections are Federal law and apply across the entire USA.'
  }, {
    q: 'Do I need a lawyer for this?',
    a: 'This guide helps you do the work a lawyer would charge you $400/hour for. It prepares you so that if you do hire one, your bill is as small as possible.'
  }, {
    q: 'Can I use this if there is no Will?',
    a: 'Yes. The "Paperwork Ghost" chapter covers exactly what to do in "Intestate" (no will) situations.'
  }];
  return <section className="bg-cream py-24 px-4" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <FadeIn className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-37">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-px bg-copper mx-auto" data-id="element-38" />
        </FadeIn>

        <FadeIn delay={0.2} className="bg-white p-6 md:p-8 border border-cream-dark shadow-sm" data-id="element-39">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-40" />)}
        </FadeIn>
      </div>
    </section>;
}